import React from 'react';

export const Button: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement> & { 
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'md' | 'lg';
}> = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  className = '', 
  ...props 
}) => {
  const baseStyle = "rounded-lg font-medium transition-colors duration-200 flex items-center justify-center gap-2 shadow-sm";
  
  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-6 py-3",
    lg: "px-8 py-4 text-lg"
  };

  const variants = {
    primary: "bg-[#2f5c96] text-white hover:bg-[#c19cca]",
    secondary: "bg-[#c19cca] text-white hover:bg-[#2f5c96]",
    outline: "border-2 border-[#2f5c96] text-[#2f5c96] hover:bg-[#2f5c96] hover:text-white bg-transparent",
    ghost: "text-gray-600 hover:bg-gray-100 shadow-none",
    white: "bg-white text-[#2f5c96] hover:bg-gray-50 border border-gray-100"
  };

  return (
    <button className={`${baseStyle} ${sizes[size]} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};